
import { defineComponent } from 'vue'
import { EpbButton } from '../../shared/epb-button'

export default defineComponent({
  name: 'OriginsLanding',
  components: { EpbButton },
  props: {
    messages: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      scrollImageUrl: require('../../../assets/media/image/scroll.webp'),
    }
  },
})
